import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { lazy } from 'react'

const Inner = lazy(() => import('./Inner'))

export const Section7216AcceptanceDialogContainer = observer(
  function Section7216AcceptanceDialogContainer() {
    const { isRequested } = useFeatures((app) => ({
      isRequested: app.account.internal.isRequested,
    }))

    if (!isRequested()) {
      return null
    }

    return <Inner />
  },
)
